import { render, staticRenderFns } from "./bsTab.vue?vue&type=template&id=54d507b8&scoped=true&"
import script from "./bsTab.vue?vue&type=script&lang=js&"
export * from "./bsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d507b8",
  null
  
)

export default component.exports